'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Message = require('./Message');

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var MessageList = function (_Component) {
	_inherits(MessageList, _Component);

	function MessageList(props) {
		_classCallCheck(this, MessageList);

		var _this = _possibleConstructorReturn(this, (MessageList.__proto__ || Object.getPrototypeOf(MessageList)).call(this, props));

		_this.state = {
			isScrolledDown: true
		};
		return _this;
	}

	_createClass(MessageList, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps() {
			var node = (0, _reactDom.findDOMNode)(this.refs.list);

			var _node$getBoundingClie = node.getBoundingClientRect();

			var height = _node$getBoundingClie.height;
			var scrollTop = node.scrollTop;
			var scrollHeight = node.scrollHeight;

			var isScrolledDown = scrollTop + height >= scrollHeight;

			if (isScrolledDown !== this.state.isScrolledDown) {
				this.setState({
					isScrolledDown: isScrolledDown
				});
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			// scrolls down if it was already the case
			if (this.state.isScrolledDown) {
				var node = (0, _reactDom.findDOMNode)(this.refs.list);
				node.scrollTop = node.scrollHeight;
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props;
			var disabled = _props.disabled;
			var messages = _props.messages;

			var className = (0, _classnames2.default)({
				'vtChat-MessageList': true,
				'vtChat-MessageList--disabled': disabled
			});

			return _react2.default.createElement(
				'ul',
				{ className: className, 'aria-live': 'polite', ref: 'list' },
				messages.map(function (message, i) {
					return _react2.default.createElement(
						'li',
						{ className: 'vtChat-MessageList-item', key: i },
						_react2.default.createElement(_Message2.default, message)
					);
				})
			);
		}
	}]);

	return MessageList;
}(_react.Component);

exports.default = MessageList;


MessageList.propTypes = {
	messages: _react.PropTypes.array.isRequired
};